export const CH = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_12222)">
      <g clipPath="url(#clip1_1073_12222)">
      <rect width="96" height="96" fill="#EF4444"/>
      <rect x="24" y="40" width="48" height="16" fill="white"/>
      <rect x="40" y="72" width="48" height="16" transform="rotate(-90 40 72)" fill="white"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_12222">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_12222">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
